// prettier-ignore
export let ABI = [{
    'anonymous': false,
    'inputs': [{ 'indexed': true, 'name': 'from', 'type': 'address' }, {
      'indexed': true,
      'name': 'to',
      'type': 'address'
    }, { 'indexed': false, 'name': 'tokens', 'type': 'uint256' }, {
      'indexed': false,
      'name': 'mode',
      'type': 'uint256'
    }],
    'name': 'Transfer',
    'type': 'event'
  }, {
    'constant': true,
    'inputs': [],
    'name': 'name',
    'outputs': [{ 'name': '', 'type': 'string' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
  }, {
    'constant': true,
    'inputs': [],
    'name': 'symbol',
    'outputs': [{ 'name': '', 'type': 'string' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
  }, {
    'constant': true,
    'inputs': [],
    'name': 'decimals',
    'outputs': [{ 'name': '', 'type': 'uint8' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
  }, {
    'constant': true,
    'inputs': [],
    'name': 'totalSupply',
    'outputs': [{ 'name': '', 'type': 'uint256' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
  }, {
    'constant': true,
    'inputs': [{ 'name': 'addr', 'type': 'address' }],
    'name': 'balanceOf',
    'outputs': [{ 'name': '', 'type': 'uint256' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
  }, {
    'constant': true,
    'inputs': [{ 'name': 'addr', 'type': 'address' }],
    'name': 'freezedOf',
    'outputs': [{ 'name': '', 'type': 'uint256' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
  }, {
    'constant': true,
    'inputs': [{ 'name': 'addr', 'type': 'address' }, { 'name': 'amount', 'type': 'uint256' }],
    'name': 'isPossibleTransfer',
    'outputs': [{ 'name': '', 'type': 'bool' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
  }, {
    'constant': false,
    'inputs': [{ 'name': 'addr', 'type': 'address' }, { 'name': 'value', 'type': 'uint256' }],
    'name': 'incFreezedToken',
    'outputs': [],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function'
  }, {
    'constant': false,
    'inputs': [{ 'name': 'addr', 'type': 'address' }, { 'name': 'value', 'type': 'uint256' }],
    'name': 'decFreezedToken',
    'outputs': [],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function'
  }, {
    'constant': false,
    'inputs': [{ 'name': '_n', 'type': 'string' }, { 'name': '_s', 'type': 'string' }, {
      'name': '_ts',
      'type': 'uint256'
    }, { 'name': '_vp', 'type': 'uint256' }],
    'name': 'initiateParameters',
    'outputs': [],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function'
  }, {
    'constant': false,
    'inputs': [{ 'name': 'from', 'type': 'address' }, { 'name': 'to', 'type': 'address' }, {
      'name': 'amount',
      'type': 'uint256'
    }, { 'name': 'mode', 'type': 'uint256' }],
    'name': 'tokenTransfer',
    'outputs': [{ 'name': 'transferId', 'type': 'uint256' }],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function'
  }, {
    'constant': false,
    'inputs': [{ 'name': 'from', 'type': 'address' }, { 'name': 'to', 'type': 'address' }],
    'name': 'sendOneToken',
    'outputs': [{ 'name': '', 'type': 'bool' }],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function'
  }, {
    'constant': false,
    'inputs': [{ 'name': 'addr', 'type': 'address' }],
    'name': 'initiateFirstOwnerBalance',
    'outputs': [],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function'
  }, {
    'constant': true,
    'inputs': [],
    'name': 'isInitiatedToken',
    'outputs': [{ 'name': '', 'type': 'bool' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
  }, {
    'constant': true,
    'inputs': [],
    'name': 'getTransferCount',
    'outputs': [{ 'name': '', 'type': 'uint256' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
  }, {
    'constant': true,
    'inputs': [{ 'name': '_id', 'type': 'uint256' }],
    'name': 'getTransfer',
    'outputs': [{ 'name': 'id', 'type': 'uint256' }, { 'name': 'from', 'type': 'address' }, {
      'name': 'to',
      'type': 'address'
    }, { 'name': 'beforesender', 'type': 'uint256' }, { 'name': 'beforereceiver', 'type': 'uint256' }, {
      'name': 'value',
      'type': 'uint256'
    }, { 'name': 'time', 'type': 'uint256' }, { 'name': 'mode', 'type': 'uint256' }, {
      'name': 'resultTime',
      'type': 'uint256'
    }, { 'name': 'status', 'type': 'uint256' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
  }, {
    'constant': false,
    'inputs': [{ 'name': 'addr', 'type': 'address' }, { 'name': 'value', 'type': 'uint256' }, {
      'name': 'who',
      'type': 'address'
    }],
    'name': 'initTreasuryWallet',
    'outputs': [{ 'name': '', 'type': 'bool' }],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function'
  }, {
    'constant': true,
    'inputs': [],
    'name': 'getTreasuryAddress',
    'outputs': [{ 'name': '', 'type': 'address' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
  }, {
    'constant': true,
    'inputs': [],
    'name': 'getTreasuryToken',
    'outputs': [{ 'name': '', 'type': 'uint256' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
  }, {
    'constant': false,
    'inputs': [{ 'name': 'to', 'type': 'address' }, { 'name': 'amount', 'type': 'uint256' }],
    'name': 'transfer',
    'outputs': [{ 'name': '', 'type': 'bool' }],
    'payable': true,
    'stateMutability': 'payable',
    'type': 'function'
  }, {
    'constant': false,
    'inputs': [{ 'name': 'to', 'type': 'address' }, { 'name': 'value', 'type': 'uint256' }, {
      'name': 'who',
      'type': 'address'
    }],
    'name': 'transfer',
    'outputs': [{ 'name': '', 'type': 'bool' }],
    'payable': true,
    'stateMutability': 'payable',
    'type': 'function'
  }, {
    'constant': false,
    'inputs': [{ 'name': 'from', 'type': 'address' }, { 'name': 'to', 'type': 'address' }, {
      'name': 'value',
      'type': 'uint256'
    }, { 'name': 'who', 'type': 'address' }],
    'name': 'transferFrom',
    'outputs': [{ 'name': '', 'type': 'bool' }],
    'payable': true,
    'stateMutability': 'payable',
    'type': 'function'
  }, {
    'constant': true,
    'inputs': [{ 'name': 'owner', 'type': 'address' }, { 'name': 'spender', 'type': 'address' }, {
      'name': 'who',
      'type': 'address'
    }],
    'name': 'allowance',
    'outputs': [{ 'name': '', 'type': 'uint256' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
  }, {
    'constant': false,
    'inputs': [{ 'name': 'spender', 'type': 'address' }, { 'name': 'value', 'type': 'uint256' }, {
      'name': 'who',
      'type': 'address'
    }],
    'name': 'approve',
    'outputs': [{ 'name': '', 'type': 'bool' }],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function'
  }]
;
